import { Role } from '@/shared/enums';
import { roleMap } from '../maps';
import { IFetchPermission } from './permission';

export interface IUserInfo {
  id: number;
  username: string;
  name: string;
  orgId: number;
  roleId: Role;
  loginAccount: string;
  organization: string;
  organizationType: string;
  position: string;
  role: string;
  upward: boolean;
  // 新增欄位
  email: string;
  avatar: string;
  account: string;
  department: string;
  gender: string;
  birthday: string;
}

export interface IFetchUserInfo {
  id: number;
  username: string;
  name: string;
  org_id: number;
  org_type: number;
  role_id: Role;
  upward: boolean;
  permissions: IFetchPermission[];
}

export function transformUserInfo(data: IFetchUserInfo): IUserInfo {
  return {
    id: data.id,
    username: data.username,
    name: data.name,
    orgId: data.org_id,
    roleId: data.role_id,
    loginAccount: '',
    organization: '',
    organizationType: '',
    position: '',
    role: roleMap.get(data.role_id) || '',
    upward: data.upward,
    // 新增欄位
    email: '',
    avatar: '',
    account: '',
    department: '',
    gender: '',
    birthday: ''
  };
}
